<template>
  <div class="info-content">
    <el-row class="info_item">
      <el-col class="info_tow_item" :span="24">
        <el-col class="two_border" :span="7">法定代表人</el-col>
        <el-col class="two_border" :span="17">{{
          archaeologyForm.legalRepresentative
        }}</el-col>
      </el-col>
    </el-row>
    <el-row class="info_item">
      <el-col class="info_tow_item" :span="24">
        <el-col class="two_border" :span="7">证照名称</el-col>
        <el-col class="two_border" :span="17">{{
          archaeologyForm.certificateTypeName
        }}</el-col>
      </el-col>
    </el-row>
    <el-row class="info_item">
      <el-col class="info_tow_item" :span="24">
        <el-col class="two_border" :span="7">证照编号</el-col>
        <el-col class="two_border" :span="17">{{
          archaeologyForm.number
        }}</el-col>
      </el-col>
    </el-row>
    <el-row class="info_item">
      <el-col class="info_tow_item" :span="24">
        <el-col class="two_border" :span="7">证照颁发日期</el-col>
        <el-col class="two_border" :span="17">{{
          archaeologyForm.passDate
        }}</el-col>
      </el-col>
    </el-row>
    <el-row class="info_item">
      <el-col class="info_tow_item" :span="24">
        <el-col class="two_border" :span="7">单位</el-col>
        <el-col class="two_border" :span="17">{{
          archaeologyForm.company
        }}</el-col>
      </el-col>
    </el-row>
    <el-row class="info_item">
      <el-col class="info_tow_item" :span="24">
        <el-col class="two_border" :span="7">地址</el-col>
        <el-col class="two_border" :span="17">{{
          archaeologyForm.address
        }}</el-col>
      </el-col>
    </el-row>
    <el-row class="info_item">
      <el-col class="info_tow_item" :span="24">
        <el-col class="two_border" :span="7">有效期(年)</el-col>
        <el-col class="two_border" :span="17">{{
          archaeologyForm.termOfValidity
        }}</el-col>
      </el-col>
    </el-row>
    <el-row class="info_item">
      <el-col class="info_tow_item" :span="24">
        <el-col class="two_border" :span="7">业务范围</el-col>
        <el-col class="two_border" :span="17">{{
          archaeologyForm.scopeOfBusiness
        }}</el-col>
      </el-col>
    </el-row>
    <el-row class="info_item">
      <el-col class="info_tow_item" :span="24">
        <el-col class="two_border" :span="7">状态</el-col>
        <el-col class="two_border" :span="17">{{
          archaeologyForm.zzState
        }}</el-col>
      </el-col>
    </el-row>
    <el-row class="info_item">
      <el-col class="info_tow_item" :span="24">
        <el-col class="two_border" :span="7">年检记录1</el-col>
        <el-col class="two_border" :span="17">{{
          archaeologyForm.annualInspectionRecordsOne
        }}</el-col>
      </el-col>
    </el-row>
    <el-row class="info_item">
      <el-col class="info_tow_item" :span="24">
        <el-col class="two_border" :span="7">年检记录2</el-col>
        <el-col class="two_border" :span="17">{{
          archaeologyForm.annualInspectionRecordsTwo
        }}</el-col>
      </el-col>
    </el-row>
    <el-row class="info_item">
      <el-col class="info_tow_item" :span="24">
        <el-col class="two_border" :span="7">年检记录3</el-col>
        <el-col class="two_border" :span="17">{{
          archaeologyForm.annualInspectionRecordsThree
        }}</el-col>
      </el-col>
    </el-row>
    <el-row class="info_item">
      <el-col class="info_tow_item" :span="24">
        <el-col class="two_border" :span="7">年检记录4</el-col>
        <el-col class="two_border" :span="17">{{
          archaeologyForm.annualInspectionRecordsFour
        }}</el-col>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import util from "../../utils/util";
export default {
  data() {
    return {
      archaeologyForm: {},
    };
  },
  mounted() {
    var url = window.location.href; //获取当前url
    var dz_url = url.split("#")[1]; //获取#/之前的字符串
    var cs = dz_url.split("?")[1]; //获取?之后的参数字符串
    var cs_arr = cs.split("&"); //参数字符串分割为数组
    var cs = {};
    for (var i = 0; i < cs_arr.length; i++) {
      //遍历数组，拿到json对象
      cs[cs_arr[i].split("=")[0]] = cs_arr[i].split("=")[1];
    }
    let ids = cs.id;
    this.getData(ids);
  },
  methods: {
    getData(urlid) {
      let Url = util.getAjaxUrl("axiosOne");
      this.$http
        .get(Url + `/api/lookExcavationCertificateQRCode/${urlid}`)
        .then((res) => {
          if (res.status == 200) {
            let zzState = res.data.data.zzState;
            let passDate = res.data.data.passDate;
            if (passDate) {
              res.data.data.passDate = this.formatDate(passDate);
            }
            if (zzState === "1") {
              res.data.data.zzState = "正常";
            } else if (zzState === "2") {
              res.data.data.zzState = "过期";
            } else if (zzState === "3") {
              res.data.data.zzState = "停用";
            } else {
              res.data.data.zzState = "无";
            }
            this.archaeologyForm = res.data.data;
          }
        });
    },
    formatDate(time) {
      if (time === null) return "";
      let date = new Date(time); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let m = date.getMonth() + 1,
        mm = m < 10 ? "0" + m : m;
      let d = date.getDate(),
        dd = d < 10 ? "0" + d : d;
      let h = date.getHours(),
        hh = h < 10 ? "0" + h : h;
      let i = date.getMinutes(),
        ii = i < 10 ? "0" + i : i;
      let s = date.getSeconds(),
        ss = s < 10 ? "0" + s : s;
      return (
        date.getFullYear() +
        "-" +
        mm +
        "-" +
        dd +
        "  " +
        hh +
        ":" +
        ii +
        ":" +
        ss
      );
    },
  },
};
</script>

<style lang="less" scoped>
.info-content {
  .info_item {
    border: 1px solid #808080;
    border-bottom: none;
    display: flex;
    justify-content: stretch;
  }
  .info_tow_item {
    height: 10em;
    display: flex;

    .two_border {
      border-right: 1px solid #808080;
      padding: 11px;
      font-size: 3.2em;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &:nth-child(odd) {
        background-color: #f2f2f2;
      }
    }

    &:last-child {
      .two_border:last-child {
        border-right: none;
      }
    }
  }
  &:last-child {
    .info_item {
      border-bottom: 1px solid #808080;
    }
  }
}
</style>